<template>
  <div class="transaction-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">Financeiro &raquo; {{ termPlural }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="transactionForm" v-slot="{ invalid }">
          <b-row>
            <b-col cols="12">
              <div class="box-cj">
                <div class="header d-flex justify-content-between">
                  <p class="title">Informações d{{ letter }} {{ termSingular }}</p>
                  <div v-if="transactionForm.attendance_guide_invoice != null">
                    <router-link tag="a" target="_blank" class="print-ico" :to="'/guia-de-atendimento/fatura/' + transactionForm.attendance_guide_invoice.id + '/imprimir'"><i class="far fa-print"></i></router-link>
                  </div>

<!--                  <div class="w-100 d-flex justify-content-between">-->
<!--                    <div>-->
<!--                      Guia de Atendimento #{{ attendanceGuideForm.internal_id }}-->
<!--                    </div>-->
<!--                    <div v-if="attendanceGuideForm.id != null">-->
<!--                      <router-link tag="a" target="_blank" class="print-ico" :to="'/guia-de-atendimento/' + attendanceGuideForm.id + '/imprimir'"><i class="far fa-print"></i></router-link>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Paciente</label>
                      <multiselect ref="multiselectPeople" :preserveSearch="true" v-model="transactionForm.patient" :options="people" track-by="name" label="name" @select="patientSelected" :loading="isLoadingPeople" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPeople" :showLabels="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || transactionForm.attendance_guide_start_datetime != null" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="transactionForm.patient != null" @mousedown.prevent.stop="transactionForm.patient = null"></div>
                        </template>
                        <template slot="noOptions">
                          <div>
                            Digite para pesquisar seus pacientes...
                          </div>
                        </template>
                        <template slot="noResult" v-if="!isLoadingPeople">
                          <div>
                            Nenhum paciente encontrado...
                          </div>
                        </template>
                      </multiselect>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Profissional</label>
                      <multiselect v-model="transactionForm.professional" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || transactionForm.attendance_guide_start_datetime != null" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="transactionForm.professional != null" @mousedown.prevent.stop="transactionForm.professional = null"></div>
                        </template>
                      </multiselect>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row class="mb-2">
                    <b-col cols="12" md="6">
                      <label class="cj-label">Descrição</label>
                      <validation-provider name="descrição" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="transactionForm.description" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="transactionForm.attendance_guide_start_datetime != null">
                      <label class="cj-label">Data do atendimento</label>
                      <b-form-input type="text" v-model="transactionForm.attendance_guide_start_datetime" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">
                        Conta
                      </label>
                      <validation-provider name="conta" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="transactionForm.bank_account" :options="bank_accounts" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }">
                          <template slot="noOptions">
                            Nenhuma cadastrada.
                          </template>
                          <template slot="afterList">
                            <li @click="showBankAccountModal">
                              <div class="multiselect__option new-patient">
                                <i class="far fa-plus-circle mr-2"></i>
                                Adicionar nova
                              </div>
                            </li>
                          </template>
                        </multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Centro de Custo</label>
                      <multiselect v-model="transactionForm.cost_center" :options="cost_centers" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="transactionForm.cost_center != null" @mousedown.prevent.stop="transactionForm.cost_center = { id: null, name: '' }"></div>
                        </template>
                        <template slot="noOptions">
                          Nenhum cadastrado.
                        </template>
                        <template slot="afterList">
                          <li @click="showCategoryModal('cost_center')">
                            <div class="multiselect__option new-patient">
                              <i class="far fa-plus-circle mr-2"></i>
                              Adicionar novo
                            </div>
                          </li>
                        </template>
                      </multiselect>
                    </b-col>
                    <b-col>
                      <validation-provider name="categoria" :rules="{ required: true }" v-slot="{ errors }">
                        <label class="cj-label">Categoria</label>
                        <multiselect v-model="transactionForm.category" :options="categories" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }">
                          <template slot="noOptions">
                            Nenhuma cadastrada.
                          </template>
                          <template slot="afterList">
                            <li @click="showCategoryModal(module)">
                              <div class="multiselect__option new-patient">
                                <i class="far fa-plus-circle mr-2"></i>
                                Adicionar nova
                              </div>
                            </li>
                          </template>
                        </multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <validation-provider name="forma de pagamento" :rules="{ required: true }" v-slot="{ errors }">
                        <label class="cj-label">Forma de Pagamento</label>
                        <multiselect v-model="transactionForm.payment_method" :options="payment_methods" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup) || split" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Vencimento</label>
                      <validation-provider name="vencimento" :rules="{ required: true }" v-slot="{ errors }">
                        <date-picker name="date" v-model="transactionForm.charge_date" v-mask="'##/##/####'" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup) || split" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="$route.meta.type == 'INCOME'">
                      <validation-provider name="valor original" :rules="{ required: true }" v-slot="{ errors }">
                        <label class="cj-label">Valor original</label>
                        <money v-model="transactionForm.original_value" class="form-control mb-2" :disabled="transactionForm.attendance_guide_invoice != null || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="$route.meta.type == 'INCOME'">
                      <validation-provider name="desconto" :rules="{ required: true, valueLowerOrEqualValue:(transactionForm.discount_is_percent ? false : {targetValue:transactionForm.original_value, targetName:'valor original'}), valueLowerOrEqual100:transactionForm.discount_is_percent }" v-slot="{ errors }">
                        <label class="cj-label">Desconto</label>
                        <money v-model="transactionForm.discount" :prefix="transactionForm.discount_is_percent ? '' : 'R$ '" :suffix="transactionForm.discount_is_percent ? ' %' : ''" :maxlength="transactionForm.discount_is_percent ? 7 : 50" class="form-control mb-2" :disabled="(transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup) || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                      <div class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="transactionForm.discount_is_percent" :disabled="(transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup) || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" />
                          <div class="state p-success">
                            <label><span>Porcentagem</span></label>
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                        <label class="cj-label">Valor</label>
                        <money v-model="transactionForm.value" class="form-control mb-2" :disabled="$route.meta.type == 'INCOME' || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                      <div class="text-center" v-if="$route.params.id == newTerm || (transactionForm.attendance_guide_invoice != null && !transactionForm.attendance_guide_invoice.finished_setup)">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="split" />
                          <div class="state p-success">
                            <label><span>Parcelar</span></label>
                          </div>
                        </div>
                        <div class="pretty p-switch p-fill mr-0" v-if="$route.params.id == newTerm">
                          <input type="checkbox" v-model="repeat" />
                          <div class="state p-success">
                            <label><span>Repetir</span></label>
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Data de lançamento</label>
                      <validation-provider name="data de lançamento" :rules="{ required: true }" v-slot="{ errors }">
                        <date-picker name="date" v-model="transactionForm.registration_date" v-mask="'##/##/####'" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || transactionForm.attendance_guide_invoice != null" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="split" cols="2"></b-col>
                    <b-col v-if="!split">
                      <div class="pretty positive p-default">
                        <input type="checkbox" v-model="transactionForm.discharged" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" />
                        <div class="state p-success">
                          <label class="cj-label">{{ ($route.meta.type == 'INCOME')?'Recebido':'Pago' }}</label>
                        </div>
                      </div>
                      <validation-provider name="data da quitação" :rules="{ required: transactionForm.discharged }" v-slot="{ errors }">
                        <date-picker name="date" v-model="transactionForm.discharge_date" v-mask="'##/##/####'" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) && !transactionForm.discharged)" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <hr v-if="split || repeat">
                  <b-row class="mb-2 justify-content-center align-items-center" v-if="split">
                    <b-col cols="auto">
                      <label class="text1">Quantidade de parcelas / lançamentos</label>
                    </b-col>
                    <b-col cols="auto">
                      <validation-provider name="número de parcelas" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="number" min="2" max="360" step="1" v-model="splitForm.times" class="text-center" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
<!--                    <b-col cols="auto">-->
<!--                      <label class="text1">parcelas</label>-->
<!--                      <label class="text1">parcelas &raquo; Cada parcela terá o valor de R$ {{ formatPrice(splitForm.value) }}</label>-->
<!--                    </b-col>-->
                  </b-row>
                  <template v-if="split">
                    <template v-for="installment in splitForm.installments">
                      <hr v-if="installment.index > 1" :key="'hr-installment' + installment.index">
                      <b-row :key="'installment' + installment.index" class="justify-content-center align-items-center">
                        <b-col cols="auto">
                          <label class="text1 mt-2">Parcela {{installment.index}}</label>
                        </b-col>
                        <b-col>
                          <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                            <label class="cj-label">Valor</label>
                            <money v-model="installment.value" class="form-control" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" :class="{ 'error': errors.length > 0 }"></money>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <validation-provider name="forma de pagamento" :rules="{ required: true }" v-slot="{ errors }">
                            <label class="cj-label">Forma de Pagamento</label>
                            <multiselect v-model="installment.payment_method" :options="payment_methods" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Vencimento</label>
                          <validation-provider name="vencimento" :rules="{ required: true }" v-slot="{ errors }">
                            <date-picker name="date" v-model="installment.charge_date" v-mask="'##/##/####'" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <div class="pretty positive p-default">
                            <input type="checkbox" v-model="installment.discharged" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" />
                            <div class="state p-success">
                              <label class="cj-label">{{ ($route.meta.type == 'INCOME')?'Recebido':'Pago' }}</label>
                            </div>
                          </div>
                          <validation-provider name="data da quitação" :rules="{ required: installment.discharged }" v-slot="{ errors }">
                            <date-picker name="date" v-model="installment.discharge_date" v-mask="'##/##/####'" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) && !installment.discharged)" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                  <b-row class="mb-2 justify-content-center align-items-center" v-if="repeat">
                    <b-col cols="3">
                      <validation-provider name="forma de pagamento" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="repeatForm.type" :options="repeatOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="auto">
                      <label class="text1">Encerrar repetição após</label>
                    </b-col>
                    <b-col cols="auto">
                      <validation-provider name="número de repetições" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="number" min="1" max="360" step="1" v-model="repeatForm.times" class="text-center" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="auto">
                      <label class="text1">vezes</label>
                    </b-col>
                  </b-row>

                  <hr v-if="transactionForm.attendance_guide_invoice_items.length > 0">
                  <b-row v-if="transactionForm.attendance_guide_invoice_items.length > 0">
                    <b-col>
                      <div class="mt-3">
                        <label class="text1">Convênio: {{ transactionForm.attendance_guide_health_plan }}</label>
                      </div>
                      <div v-if="transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.authorization_code != null">
                        <label class="text1">Senha de autorização: {{ transactionForm.attendance_guide_invoice.authorization_code }}</label>
                      </div>
                      <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                        <thead>
                        <tr>
                          <th v-if="transactionForm.professional.is_dentist">Dente/Área</th>
                          <th v-if="transactionForm.professional.is_dentist">Face(s)</th>
                          <th>Procedimento</th>
                          <th>Quantidade</th>
                          <th>Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) of transactionForm.attendance_guide_invoice_items" :key="index">
                          <td v-if="transactionForm.professional.is_dentist">{{ item.tooth != null ? item.tooth : '-' }}</td>
                          <td v-if="transactionForm.professional.is_dentist">{{ item.faces != null ? item.faces : '-' }}</td>
                          <td>{{ item.procedure.name }}</td>
                          <td>{{ item.amount }}</td>
                          <td>R$ {{ formatPrice(item.value) }}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td></td>
                            <td class="text-right">Subtotal:</td>
                            <td>
                              R$ {{ formatPrice(transactionForm.attendance_guide_invoice.original_value) }}
                            </td>
                          </tr>
                          <tr>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td></td>
                            <td class="text-right">Desconto:</td>
                            <td v-if="transactionForm.attendance_guide_invoice.finished_setup">
                              - {{ (transactionForm.attendance_guide_invoice.discount_is_percent ? '' : 'R$ ') + formatPrice(transactionForm.attendance_guide_invoice.discount) + (transactionForm.attendance_guide_invoice.discount_is_percent ? ' %' : '') }}
                            </td>
                            <td v-else>
                              - {{ (transactionForm.discount_is_percent ? '' : 'R$ ') + formatPrice(transactionForm.discount) + (transactionForm.discount_is_percent ? ' %' : '') }}
                            </td>
                          <tr>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td></td>
                            <td class="text-right">Total:</td>
                            <td v-if="transactionForm.attendance_guide_invoice.finished_setup">
                              R$ {{ formatPrice(transactionForm.attendance_guide_invoice.value) }}{{transactionForm.attendance_guide_invoice.installments > 1 ? (' (' + transactionForm.attendance_guide_invoice.installments + ' parcelas)') : ''}}
<!--                              <span v-if="transactionForm.discharged" class="text-success ml-4">RECEBIDO</span>-->
                            </td>
                            <td v-else>
                              R$ {{ formatPrice(transactionForm.value) }}{{split && splitForm.times > 1 ? (' (' + splitForm.times + ' parcelas)') : ''}}
<!--                              <span v-if="transactionForm.discharged" class="text-success ml-4">RECEBIDO</span>-->
                            </td>
                          </tr>
                          <tr>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td></td>
                            <td class="text-right">Comissão:</td>
                            <td v-if="transactionForm.attendance_guide_invoice.finished_setup">
                              R$ {{ formatPrice(transactionForm.professional.commission_percentage * transactionForm.attendance_guide_invoice.value / 100.0) }}
                            </td>
                            <td v-else>
                              R$ {{ formatPrice(transactionForm.professional.commission_percentage * transactionForm.value / 100.0) }}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit) || canRemove)">
                  <template v-if="transactionForm.attendance_guide_invoice != null && !transactionForm.attendance_guide_invoice.finished_setup">
                    <b-button variant="warning" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="saveInvoiceDraft">Salvar rascunho</b-button>
                    <b-button variant="primary" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="finishInvoiceSetup">Finalizar faturamento</b-button>
                  </template>
                  <b-button v-else variant="primary" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="saveTransaction">Salvar</b-button>
                  <b-button variant="danger" v-if="transactionForm.id != null && canRemove" @click="deleteTransaction">Excluir</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="$route.meta.type == 'INCOME'">
            <b-col>
              <div class="box-cj">
                <div class="header">
                  Dados do(a) responsável pelo pagamento
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col>
                      <div class="pretty p-switch p-fill mr-0">
                        <input type="checkbox" v-model="transactionForm.use_patient_data" />
                        <div class="state p-success">
                          <label><span>Usar dados do(a) paciente</span></label>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Nome</label>
                      <b-form-input type="text" v-model="transactionForm.payer_name" :disabled="!canManage"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">E-mail</label>
                      <b-form-input type="text" v-model="transactionForm.payer_email" :disabled="!canManage"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CPF / CNPJ</label>
                      <validation-provider name="CPF / CNPJ" :rules="{ cpfOrCnpj: true }" v-slot="{ errors }">
                        <b-form-input type="tel" v-model="transactionForm.payer_document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##', '##.###.###/####-##']" :disabled="!canManage"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">CEP</label>
                      <b-form-input type="tel" v-model="transactionForm.payer_address.zip_code" v-mask="'#####-###'" :disabled="!canManage" v-on:blur="findCep(transactionForm.payer_address.zip_code)"></b-form-input>
                    </b-col>
                    <b-col cols="8">
                      <label class="cj-label">Endereço</label>
                      <b-form-input type="text" v-model="transactionForm.payer_address.address" ref="address" :disabled="!canManage"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Número</label>
                      <b-form-input type="tel" v-model="transactionForm.payer_address.number" ref="number" :disabled="!canManage"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Complemento</label>
                      <b-form-input type="text" v-model="transactionForm.payer_address.complement" :disabled="!canManage"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Bairro</label>
                      <b-form-input type="text" v-model="transactionForm.payer_address.neighborhood" :disabled="!canManage"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Cidade</label>
                      <b-form-input type="text" v-model="transactionForm.payer_address.city" :disabled="!canManage"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Estado</label>
                      <b-form-input type="text" v-model="transactionForm.payer_address.state" :disabled="!canManage"></b-form-input>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit) || canRemove)">
                  <template v-if="transactionForm.attendance_guide_invoice != null && !transactionForm.attendance_guide_invoice.finished_setup">
                    <b-button variant="warning" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="saveInvoiceDraft">Salvar rascunho</b-button>
                    <b-button variant="primary" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="finishInvoiceSetup">Finalizar faturamento</b-button>
                  </template>
                  <b-button v-else variant="primary" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="saveTransaction">Salvar</b-button>
                  <b-button variant="danger" v-if="transactionForm.id != null && canRemove" @click="deleteTransaction">Excluir</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>

    <b-modal id="bank-account-modal" class="bank-account-modal" :modalClass="'bank-account-modal'" @hidden="resetBankAccountModal">
      <template slot="modal-header">
        Adicionar nova conta
      </template>
      <template slot="default">
        <validation-observer ref="bankAccountForm" v-slot="{ invalid }">
          <b-row>
            <b-col>
              <label class="cj-label">Nome</label>
              <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                <b-form-input type="text" v-model="bankAccountForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
<!--            <b-col>-->
<!--              <label class="cj-label">Saldo</label>-->
<!--              <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">-->
<!--                <money v-model="bankAccountForm.opening_balance" class="form-control" :class="{ 'error': errors.length > 0 }"></money>-->
<!--                <span class="cj-error">{{ errors[0] }}</span>-->
<!--              </validation-provider>-->
<!--            </b-col>-->
          </b-row>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('bank-account-modal')">Fechar</b-button>
        <b-button size="sm" variant="success" @click="saveBankAccount">Adicionar</b-button>
      </template>
    </b-modal>

    <b-modal id="category-modal" class="category-modal" :modalClass="'category-modal'" @hidden="resetCategoryModal">
      <template slot="modal-header">
        Adicionar {{ (categoryForm.type == 'cost_center')?'novo centro de custo':'nova categoria' }}
      </template>
      <template slot="default">
        <validation-observer ref="categoryForm" v-slot="{ invalid }">
          <b-row>
            <b-col>
              <label class="cj-label">Nome</label>
              <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                <b-form-input type="text" v-model="categoryForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('category-modal')">Fechar</b-button>
        <b-button size="sm" variant="success" @click="saveCategory">Adicionar</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>

  import axios from "axios";

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        termSingular: '',
        termPlural: '',
        url: '',
        letter: '',
        newTerm: '',
        module: '',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        saveAsDraft: false,

        selectedPatient: null,

        transactionForm: {
          id: null,
          type: this.$route.meta.type,
          patient: null,
          professional: null,
          bank_account: null,
          cost_center: null,
          category: null,
          payment_method: null,
          description: '',
          original_value: '',
          discount: '',
          discount_is_percent: true,
          value: '',
          registration_date: '',
          charge_date: '',
          discharged: false,
          discharge_date: '',
          attendance_guide_invoice: null,
          attendance_guide_start_datetime: null,
          attendance_guide_health_plan: '',
          attendance_guide_authorization_code: '',
          attendance_guide_invoice_items: [],
          use_patient_data: false,
          payer_name: '',
          payer_email: '',
          payer_document: '',
          payer_address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          }
        },

        professionals: [],
        bank_accounts: [],
        cost_centers: [],
        categories: [],
        payment_methods: [],

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },

        people: [],
        isLoadingPeople: false,

        split: false,
        splitForm: {
          times: '',
          value: 0,
          installments: []
        },

        repeat: false,
        repeatForm: {
          type: { value: 'monthly', name: 'Mensalmente' },
          times: ''
        },

        repeatOptions: [
          { value: 'daily', name: 'Diariamente' },
          { value: 'weekly', name: 'Semanalmente' },
          { value: 'biweekly', name: 'Quinzenalmente' },
          { value: 'monthly', name: 'Mensalmente' },
          { value: 'yearly', name: 'Anualmente' }
        ],

        bankAccountForm: {
          name: '',
          opening_balance: 0
        },

        categoryForm: {
          type: '',
          name: ''
        }
      }
    },
    watch: {
      'split': {
        handler(newValue) {
          if(newValue) {
            this.repeat = false;
            if(this.splitForm.times === '') {
              this.splitForm.times = 2;
            }
          }
          else {
            this.splitForm.times = '';
            this.splitForm.installments = [];
          }
        }
      },
      'repeat': {
        handler(newValue) {
          if(newValue)
            this.split = false;
        }
      },
      'splitForm.times': {
        handler(newValue) {
          let remainingValue = this.transactionForm.value,
              splitValue = remainingValue/parseInt(newValue);
          splitValue = splitValue.toFixed(2) * 1.0;
          this.splitForm.value = splitValue;
          this.splitForm.installments = [];
          let chargeDate = this.transactionForm.charge_date;
          if(chargeDate !== '') {
            chargeDate = this.moment(chargeDate, 'DD/MM/YYYY');
          }
          let installmentValues = [];
          for(let index = 1; index <= newValue; index++) {
            if(index == newValue) {
              installmentValues.push(remainingValue);
            }
            else {
              installmentValues.push(splitValue);
              remainingValue -= splitValue;
            }
          }
          installmentValues.sort().reverse();
          for(let index = 1; index <= newValue; index++) {
            if(chargeDate !== '' && index > 1) {
              chargeDate = chargeDate.add(1, 'month');
            }
            this.splitForm.installments.push({
              index: index,
              value: installmentValues[index - 1],
              payment_method: this.transactionForm.payment_method != null ? this.transactionForm.payment_method : null,
              charge_date: chargeDate !== '' ? chargeDate.format('DD/MM/YYYY') : '',
              discharged: false,
              discharge_date: '',
            });
          }
          console.log(this.splitForm.installments)
        }
      },
      'transactionForm.original_value': {
        handler() {
          this.calculateLiquidValue();
        }
      },
      'transactionForm.discount': {
        handler() {
          this.calculateLiquidValue();
        }
      },
      'transactionForm.discount_is_percent': {
        handler() {
          this.calculateLiquidValue();
        }
      },
      'transactionForm.value': {
        handler(newValue) {
          if(this.split) {
            let splitValue = newValue/parseInt(this.splitForm.times);
            this.splitForm.value = splitValue;
          }
        }
      },
      'transactionForm.use_patient_data': {
        handler(newValue) {
          if(newValue && this.selectedPatient != null) {
            this.transactionForm.payer_name = this.selectedPatient.name;
            this.transactionForm.payer_email = this.selectedPatient.email;
            this.transactionForm.payer_document = this.selectedPatient.document;
            if(this.selectedPatient.address != null) {
              this.transactionForm.payer_address = this.selectedPatient.address;
            }
          }
        }
      }
    },
    async mounted () {
      if(this.$route.meta.type == 'INCOME') {
        this.termSingular = 'receita';
        this.termPlural = 'contas a receber';
        this.url = 'contas-a-receber';
        this.letter = 'a';
        this.newTerm = 'cadastrar-receita';
        this.module = 'incomes';
      } else if(this.$route.meta.type == 'EXPENSE') {
        this.termSingular = 'despesa';
        this.termPlural = 'contas a pagar';
        this.url = 'contas-a-pagar';
        this.letter = 'a';
        this.newTerm = 'cadastrar-despesa';
        this.module = 'expenses';
      }

      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_manage');
      if(this.canSee == false || !this.helpers.planHasPermission('financial')) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' });
        return;
      }
      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      await this.api.getPeople({type: 'PROFESSIONAL'}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.professionals = [];
        res.data.data.forEach(professional => {
          this.professionals.push({value: professional.id, name: professional.name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Professional', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os profissionais da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Professional', err.response);
      });

      await this.getBankAccounts();
      await this.getCategory('cost_center');
      await this.getCategory(this.module);
      await this.getCategory('payment_method');

      if(this.$route.params.id != this.newTerm) {
        await this.api.getTransaction(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          let transactionData = res.data;

          let dentistSpecialty = transactionData.professional != null ? transactionData.professional.specialities.find(specialty => {
            return specialty.group === 'Odontologia';
          }) : undefined;
          this.transactionForm = {
            id: transactionData.id,
            type: transactionData.type,
            patient: (transactionData.patient != null) ? {
              value: transactionData.patient.id,
              name: transactionData.patient.name,
              email: transactionData.patient.email,
              document: transactionData.patient.email,
              address: transactionData.patient.address
            } : null,
            professional: (transactionData.professional != null) ? {
              value: transactionData.professional.id,
              name: transactionData.professional.name,
              commission_percentage: transactionData.professional.commission_percentage,
              is_dentist: dentistSpecialty !== undefined,
            } : null,
            bank_account: (transactionData.bank_account != null) ? {
              value: transactionData.bank_account.id,
              name: transactionData.bank_account.name
            } : null,
            cost_center: (transactionData.costCenter != null) ? {
              value: transactionData.cost_center.id,
              name: transactionData.cost_center.name
            } : null,
            category: (transactionData.category != null) ? {
              value: transactionData.category.id,
              name: transactionData.category.name
            } : null,
            payment_method: (transactionData.payment_method != null) ? {
              value: transactionData.payment_method.id,
              name: transactionData.payment_method.name
            } : null,
            repeat_id: transactionData.repeat_id,
            description: transactionData.description,
            original_value: transactionData.original_value,
            discount: transactionData.discount,
            discount_is_percent: transactionData.discount_is_percent,
            value: transactionData.value,
            registration_date: this.moment(transactionData.registration_date).format('DD/MM/YYYY'),
            charge_date: transactionData.charge_date != null ? this.moment(transactionData.charge_date).format('DD/MM/YYYY') : '',
            discharged: transactionData.discharged,
            discharge_date: (this.moment(transactionData.discharge_date).isValid())?this.moment(transactionData.discharge_date).format('DD/MM/YYYY'):'',
            attendance_guide_invoice: transactionData.attendance_guide_invoice,
            attendance_guide_start_datetime: transactionData.attendance_guide_start_datetime != null ? this.moment(transactionData.attendance_guide_start_datetime).format('DD/MM/YYYY HH:mm') : null,
            attendance_guide_health_plan: transactionData.attendance_guide_health_plan,
            attendance_guide_invoice_items: transactionData.attendance_guide_invoice_items,
            use_patient_data: false,
            payer_name: transactionData.payer_name,
            payer_email: transactionData.payer_email,
            payer_document: transactionData.payer_document,
            payer_address: transactionData.payer_address,
          };
          if(transactionData.payer_address == null) {
            this.transactionForm.payer_address = {
              id: null,
              zip_code: null,
              address: null,
              number: null,
              complement: null,
              neighborhood: null,
              city: null,
              state: null,
              country: 'Brazil'
            };
          }
          this.selectedPatient = this.transactionForm.patient;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Transaction', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/financeiro/' + this.url});

          this.$swal('Ops...', 'Não conseguimos carregar esta ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Transaction', err.response);
        });
      } else {
        this.transactionForm.registration_date = this.moment().format('DD/MM/YYYY');
        this.canPerformAction = true;
      }
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      getBankAccounts() {
        this.api.getBankAccounts().then(res => {
          if(this.leavingPage) {
            return;
          }
          this.bank_accounts = [];
          res.data.forEach(category => {
            this.bank_accounts.push({value: category.id, name: category.name});
          });

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Bank Accounts', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar as contas bancárias! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Bank Accounts', err.response);
        });
      },

      getCategory(category) {
        this.api.getCategories({ type: category }).then(res => {
          if(this.leavingPage) {
            return;
          }
          let categoriesAux = [];
          res.data.forEach(category => {
            categoriesAux.push({value: category.id, name: category.name});
          });

          if(category == 'cost_center') {
            this.cost_centers = categoriesAux;
          } else if(category == 'incomes' || category == 'expenses') {
            this.categories = categoriesAux;
          } else if(category == 'payment_method') {
            this.payment_methods = categoriesAux;
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Categories', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar as categorias! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Categories', err.response);
        });
      },

      resetBankAccountModal() {
        this.bankAccountForm = {
          name: '',
          opening_balance: 0
        }
      },

      calculateLiquidValue() {
        let value = this.transactionForm.original_value;
        if(this.transactionForm.discount > 0) {
          value -= this.transactionForm.discount_is_percent ? (value * this.transactionForm.discount/100.0) : this.transactionForm.discount;
        }
        this.transactionForm.value = value;
        if(this.split) {
          let splitValue = value/parseInt(this.splitForm.times);
          this.splitForm.value = splitValue;
        }
      },

      showBankAccountModal() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        this.$bvModal.show('bank-account-modal');
        this.canPerformAction = true;
      },

      async saveBankAccount() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.bankAccountForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        this.eventBus.$emit('IS_LOADING', true);
        this.api.storeBankAccount(this.bankAccountForm).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          if (res.status == 201) {
            this.transactionForm.bank_account = { id: res.data.id, name: res.data.name };
            this.getBankAccounts();

            this.$swal('Uhull \\o/', 'A conta bancária foi criada com sucesso!', 'success');
          } else {
            this.$swal('Ops...', 'Ocorreu um erro ao criar a conta bancária! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Store Bank Account', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = 'Não conseguimos criar esta conta bancária! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Store Bank Account', err.response);
        });

        this.$bvModal.hide('bank-account-modal');
        this.canPerformAction = true;
      },

      resetCategoryModal() {
        this.categoryForm = {
          type: '',
          name: ''
        }
      },

      showCategoryModal(type) {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;
        this.categoryForm.type = type;

        this.$bvModal.show('category-modal');
        this.canPerformAction = true;
      },

      async saveCategory() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.categoryForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        this.eventBus.$emit('IS_LOADING', true);
        this.api.storeCategory(this.categoryForm).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          if (res.status == 201) {
            if(this.categoryForm.type == 'cost_center') {
              this.transactionForm.cost_center = { id: res.data.id, name: res.data.name };
            } else if(this.categoryForm.type == 'incomes' || this.categoryForm.type == 'expenses') {
              this.transactionForm.category = { id: res.data.id, name: res.data.name };
            }
            this.getCategory(this.categoryForm.type);

            if(this.categoryForm.type == 'cost_center') {
              this.$swal('Uhull \\o/', 'O centro de custo foi criado com sucesso!', 'success');
            } else if(this.categoryForm.type == 'incomes' || this.categoryForm.type == 'expenses') {
              this.$swal('Uhull \\o/', 'A categoria foi criada com sucesso!', 'success');
            }
          } else {
            if(this.categoryForm.type == 'cost_center') {
              this.$swal('Ops...', 'Ocorreu um erro ao criar o centro de custo! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            } else if(this.categoryForm.type == 'incomes' || this.categoryForm.type == 'expenses') {
              this.$swal('Ops...', 'Ocorreu um erro ao criar a categoria! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Store Category', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = '';
          if(this.categoryForm.type == 'cost_center') {
            msg = 'Não conseguimos criar este centro de custo! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
          } else if(this.categoryForm.type == 'incomes' || this.categoryForm.type == 'expenses') {
            msg = 'Não conseguimos criar esta categoria! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
          }

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Store Category', err.response);
        });

        this.$bvModal.hide('category-modal');
        this.canPerformAction = true;
      },

      async saveInvoiceDraft() {
        let doSave = false;

        if(this.split) {
          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Ao salvar como rascunho, as informações de parcelamento serão perdidas. Você terá que preenchê-las novamente quando for finalizar o faturamento.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doSave = true;
            }
          });
        }
        else {
          doSave = true;
        }
        if(doSave) {
          this.saveAsDraft = true;
          await this.saveTransaction();
        }
      },

      async finishInvoiceSetup() {
        let doSave = false;

        await this.$swal({
          title: 'Você tem certeza?',
          text: 'Ao finalizar o faturamento, as informações não poderão mais ser alteradas. Somente será possível informar o recebimento ou excluir.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            doSave = true;
          }
        });
        if(doSave) {
          await this.saveTransaction();
        }
      },

      async saveTransaction() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit))) {
          this.saveAsDraft = false;
          return false;
        }

        if(this.split) {
          let value = this.transactionForm.value,
              installmentsValue = 0;

          this.splitForm.installments.forEach(installment => {
            installmentsValue += installment.value;
          });
          installmentsValue = installmentsValue.toFixed(2) * 1.0;
          if(value != installmentsValue) {
            this.$swal('Ops...', 'O valor total das parcelas está diferente do campo Valor!', 'error');
            return false;
          }
        }

        this.canPerformAction = false;

        const isValid = await this.$refs.transactionForm.validate();
        if(!isValid) {
          this.saveAsDraft = false;
          this.canPerformAction = true;
          return false;
        }

        let transactionData = {
          id: this.transactionForm.id,
          type: this.$route.meta.type,
          patient_id: (this.transactionForm.patient != null)?this.transactionForm.patient.value:null,
          professional_id: (this.transactionForm.professional != null)?this.transactionForm.professional.value:null,
          bank_account_id: this.transactionForm.bank_account.value,
          cost_center_id: (this.transactionForm.cost_center != null)?this.transactionForm.cost_center.value:null,
          category_id: this.transactionForm.category.value,
          payment_method_id: this.transactionForm.payment_method != null ? this.transactionForm.payment_method.value : null,
          description: this.transactionForm.description,
          original_value: this.transactionForm.original_value,
          discount: this.transactionForm.discount,
          discount_is_percent: this.transactionForm.discount_is_percent,
          value: this.transactionForm.value,
          registration_date: this.transactionForm.registration_date,
          charge_date: this.transactionForm.charge_date,
          discharged: this.transactionForm.discharged,
          discharge_date: this.transactionForm.discharge_date,
          save_as_draft: this.saveAsDraft ? 1 : 0,
        };

        if(this.split || this.repeat) {
          transactionData.repeat = {
            method: (this.split)?'split':'repeat',
            times: (this.split)?this.splitForm.times:this.repeatForm.times,
            installments: [],
            recurrence: (this.repeat)?this.repeatForm.type.value:null
          };
          if(this.split) {
            this.splitForm.installments.forEach(installment => {
              transactionData.repeat.installments.push({
                value: (installment.value*1.0).toFixed(2) * 1.0,
                payment_method_id: installment.payment_method.value,
                charge_date: installment.charge_date,
                discharged: installment.discharged,
                discharge_date: installment.discharge_date,
              });
            });
          }
        }
        if(this.$route.meta.type == 'INCOME') {
          transactionData.payer_name = this.transactionForm.payer_name;
          transactionData.payer_email = this.transactionForm.payer_email;
          transactionData.payer_document = this.transactionForm.payer_document;
          transactionData.payer_address = this.transactionForm.payer_address;
        }

        this.eventBus.$emit('IS_LOADING', true);
        if (this.transactionForm.id == null) {
          this.api.storeTransaction(transactionData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.saveAsDraft = false;

            if (res.status == 201) {
              this.$swal('Uhull \\o/', 'A '+this.termSingular+' foi criada com sucesso!', 'success').then(() => {
                this.$router.push({path: '/financeiro/'+this.url});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao criar a '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Transaction', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.saveAsDraft = false;

            let msg = 'Não conseguimos criar esta '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Transaction', err.response);
          });
        } else {
          this.api.updateTransaction(this.transactionForm.id, transactionData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.saveAsDraft = false;

            if (res.status == 200) {
              this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi atualizada com sucesso!', 'success').then(() => {
                this.$router.push({path: '/financeiro/'+this.url});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Transaction', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.saveAsDraft = false;

            let msg = 'Não conseguimos atualizar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Transaction', err.response);
          });
        }
      },

      async deleteTransaction() {
        if(this.canRemove) {
          let doCancel = false;
          let deleteType = 'this';

          if(this.transactionForm.repeat_id != null) {
            await this.$swal({
              title: 'Excluir ' + this.termSingular + ' recorrente',
              input: 'select',
              inputOptions: {
                this: 'Esta ' + this.termSingular,
                future: 'Esta e as ' + this.termSingular + 's futuras',
                all: 'Todas as ' + this.termSingular + 's'
              },
              showCancelButton: true,
              cancelButtonText: 'Cancelar',
              inputValidator: (value) => {
                deleteType = value;
              }
            }).then((res) => {
              console.log(res);
              if(res.value) {
                doCancel = true;
              }
            });
          }
          else {
            await this.$swal({
              title: 'Você tem certeza?',
              text: 'Esta ação não poderá ser desfeita!',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancelar',
              focusCancel: true
            }).then((res) => {
              if(res.value) {
                doCancel = true;
              }
            });
          }

          if(doCancel) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
              this.api.deleteTransaction(this.transactionForm.id, deleteType).then(res => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                if (res.status == 204) {
                  this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi excluída com sucesso!', 'success').then(() => {
                    this.$router.push({path: '/financeiro/'+this.url});
                  });
                } else {
                  this.$swal('Ops...', 'Ocorreu um erro ao excluir a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
                }

                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Response Delete Transaction', res);
              }).catch(err => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                this.$swal('Ops...', 'Não conseguimos excluir esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Error Delete Transaction', err.response);
              });
          }
        }
      },

      limitPeople(qty) {
        return 'e '+qty+' outros pacientes';
      },

      findPeople(query) {
        this.people = [];
        if(query.length >= 3 && !this.isLoadingPeople) {
          this.isLoadingPeople = true;
          this.api.getPeople({ type: 'PATIENT', name: query }).then(res => {
            if(this.leavingPage) {
              return;
            }
            this.isLoadingPeople = false;

            res.data.data.forEach(patient => {
              this.people.push({
                value: patient.id,
                name: patient.name,
                email: patient.email,
                document: patient.document,
                address: patient.address
              });
            });
          }).catch(err => {
            if(this.leavingPage) {
              return;
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Patients', err.response);
          });
        }
      },

      findCep(value) {
        if(value == '00000-000' || value == '99999-999') {
          this.transactionForm.payer_address.address = 'Atendimento online';
          this.transactionForm.payer_address.number = '-';
          this.transactionForm.payer_address.neighborhood = '-';
          this.transactionForm.payer_address.city = '-';
          this.transactionForm.payer_address.state = '-';
        } else if(value.length == 9) {
          axios.get('https://viacep.com.br/ws/'+value+'/json/').then(res => {
            if(typeof res.data.erro == 'undefined') {
              let cepData = res.data;
              this.transactionForm.payer_address.address = cepData.logradouro;
              this.transactionForm.payer_address.neighborhood = cepData.bairro;
              this.transactionForm.payer_address.city = cepData.localidade;
              this.transactionForm.payer_address.state = cepData.uf;

              this.$refs.number.$el.focus();
            } else {

              this.$refs.address.$el.focus();
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response CEP', res);
          }).catch(err => {
            this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error CEP', err.response);
          });
        }
      },

      patientSelected(selectedOption) {
        if(this.$route.meta.type == 'INCOME') {
          this.selectedPatient = {
            name: selectedOption.name,
            email: selectedOption.email,
            document: selectedOption.email,
            address: selectedOption.address
          }
        }
      },

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      goBack() {
        this.$router.push({path: '/financeiro/' + this.url});
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .transaction-form {
    padding: 20px 0;

    .text1 {
      font-size: 14px;
      color: $cadetGray;
      margin-bottom: 0;
    }


  }
</style>
